/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { Button, Filter, Form, useErrorState } from '@finbeat/react-toolkit';
import { AxiosError } from 'axios';
import { getRoleTypes } from 'axios/roleApi';
import useApi from 'hooks/useApi';
import { AxiosErrorResponse } from 'models/api/axiosErrorResponse';
import { RoleFilter as RoleFilterType, RoleType } from 'models/api/roles';
import { RefObject, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { useQuery } from 'react-query';
import { CardBody, CardFooter } from 'reactstrap';
import RoleFilter from '../../Roles/RoleFilter';
import '../Users.scss';

const UserRoleFilter = ({
    setFilter,
    defautValues,
}: {
    defautValues: Filter<RoleFilterType>;
    setFilter: (data: Filter<RoleFilterType>) => void;
}) => {
    const className = 'user-role-filter';
    const api = useApi();
    const formRef = useRef<HTMLFormElement>(null);
    const { handleRequestError } = useErrorState();
    const [roleTypes, setRoleTypes] = useState<RoleType[]>([]);

    const getRoleTypesQuery = useQuery('roleTypes', () => getRoleTypes(api), {
        onSuccess: (data) => {
            setRoleTypes(data);
        },
        onError: (err: AxiosError<AxiosErrorResponse>) => {
            handleRequestError(err);
        },
    });

    return (
        <Form
            onSubmit={(data) => {
                setFilter(data);
            }}
            innerRef={formRef}
            defaultValues={defautValues}
            clearAfterSubmit={false}
        >
            <CardBody>
                <RoleFilter
                    roleTypes={roleTypes}
                    getRoleTypesQuery={getRoleTypesQuery}
                    filterOptions={{ typeId: { hide: true } }}
                />
            </CardBody>
            <CardFooter className={`${className}__footer`} style={{ display: 'flex' }}>
                <BackToDefaultButton formRef={formRef} />
                <Button color="primary" type="submit">
                    <Trans i18nKey="BackOfficeSearch" />
                </Button>
            </CardFooter>
        </Form>
    );
};

const BackToDefaultButton = ({ formRef }: { formRef: RefObject<HTMLFormElement> }) => {
    const { reset } = useFormContext<Filter<RoleFilterType>>();
    return (
        <Button
            onClick={() => {
                reset();
                formRef.current?.requestSubmit();
            }}
        >
            <Trans i18nKey="BackOfficeDefault" />
        </Button>
    );
};

export default UserRoleFilter;
